import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { useTranslate } from 'react-admin';

import { HintBadge } from '../../popovers/HintBadge';


export const PaperCustomOverlay = withStyles({
	root: {
		position: 'relative',

		'&::before': {
			boxSizing: 'border-box',
			content: '""',
			zIndex: 10000,
			pointerEvents: 'none',
			position: 'absolute',
			left: 0,
			top: 0,
			width: '100%',
			height: '100%',
			backgroundColor: 'rgba(255,255,255,0.5)',
			border: '4px dashed #aaa',
			borderRadius: '3px',
		},
	}
})(Paper);


const OverlayLabel = withStyles({
	root: {
		zIndex: 10001,
		pointerEvents: 'none',
		fontFamily: 'sans-serif',
		fontSize: '1.4em',
		fontWeight: 600,
		textTransform: 'uppercase',
		position: 'absolute',
		left: '50%',
		top: '50%',
		transform: 'translate(-50%, -50%)',
	},
})(({ classes, labelKey }) => {
	const translate = useTranslate();
	return <div className={classes.root}>{translate(labelKey)}</div>;
});

function PasteHintBadge() {
	const translate = useTranslate();
	return (
		<HintBadge>{translate('osfc.fields.document.paste_hint')}</HintBadge>
	);
}


export class DropPaper extends React.Component {
	state = {
		dragging: false,
		hover: false,
	}

	componentDidMount() {
		document.addEventListener('paste', this.handlePaste);
	}

	componentWillUnmount() {
		document.removeEventListener('paste', this.handlePaste);
	}

	setDragging = (dragging) => {
		this.setState(state => ({
			...state,
			dragging: dragging,
		}))
	}

	setHover = (hover) => {
		this.setState(state => ({
			...state,
			hover: hover,
		}))
	}

	handleStop = (e) => {
		e.preventDefault();
		e.stopPropagation();
	}

	handleDragIn = (e) => {
		this.handleStop(e);
		if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
			this.setDragging(true);
		}
	}

	handleDragOut = (e) => {
		this.handleStop(e);
		this.setDragging(false);
	}

	handleDrop = (e) => {
		this.handleStop(e);
		this.setDragging(false);
		if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
			this.props.processDocument(e.dataTransfer.files[0]);
		}
	}

	getPastedFile = (clipboardData) => {
		const items = Array.from((clipboardData && clipboardData.items) || []);
		const fileItem = items.find((item) => item.kind === 'file');
		return fileItem ? fileItem.getAsFile() : null;
	}

	handlePaste = (e) => {
		if (!this.state.hover) return;
		if (this.props.uploading || this.props.draggable === false) return;
		const file = this.getPastedFile(e.clipboardData);
		if (!file) return;
		e.preventDefault();
		this.props.processDocument(file);
	}

	render() {
		const { uploading, processDocument, draggable = true, ...rest }  = this.props;

		const showPasteHint =
			draggable && this.state.hover && !this.state.dragging && !uploading;

		let Component = Paper;
		let overlayLabelKey = null;
		if (this.state.dragging) {
			Component = PaperCustomOverlay;
			overlayLabelKey = 'osfc.fields.document.add_document';
		} else if (uploading) {
			Component = PaperCustomOverlay;
			overlayLabelKey = 'osfc.fields.document.uploading';
		}

		let dragOptions = {};
		if (draggable) {
			dragOptions = {
				onDragEnter: this.handleDragIn,
				onDragLeave: this.handleDragOut,
				onDragOver: this.handleStop,
				onDrop: this.handleDrop,
			};
		}

		return (
			<div
				style={{width: '100%', position: 'relative'}}
				onMouseEnter={() => this.setHover(true)}
				onMouseLeave={() => this.setHover(false)}
				{...dragOptions}
			>
				<Component {...rest} />
				{overlayLabelKey && <OverlayLabel labelKey={overlayLabelKey} />}
				{showPasteHint && <PasteHintBadge />}
			</div>
		);
	}
}
